import React, { useState } from "react";
import { observer } from "mobx-react";
import { WeekYear } from "@bonliva-crm/common";
import { useGetTravelConfirmationPageDataQuery } from "@graphql";
import { useNavigation } from "@navigation";
import { Spinner } from "@components";
import { TravelConfirmationStore } from "./TravelConfirmationStore";
import { TravelConfirmationForm } from "@bookings/BookingHospitality/TravelConfirmation/TravelConfirmationForm";
import { TravelConfirmationFormData } from "@bookings/BookingHospitality/TravelConfirmation/utils";

type Props = {
  bookingId: string;
  files: File[];
  week: WeekYear;
};

export const TravelConfirmationCreatePage = observer((props: Props) => {
  const [formStore, setFormStore] = useState<TravelConfirmationStore>(null);

  const { loading, error } = useGetTravelConfirmationPageDataQuery({
    variables: { bookingId: props.bookingId },
    onCompleted: (data) => {
      const initial: TravelConfirmationFormData = {
        files: props.files,
        weeks: [
          {
            weekYear: props.week,
            isTravel: true,
            cost: "0",
            description: null,
            startDate: null,
            endDate: null,
            note: null
          }
        ],
        totalCost: ""
      };
      const store = new TravelConfirmationStore(
        null,
        props.bookingId,
        data.bookingById,
        initial
      );
      setFormStore(store);
    }
  });

  const nav = useNavigation();

  if (loading) {
    return <Spinner fullHeight />;
  }

  if (error) {
    throw new Error(error.toString());
  }

  nav.lockNavigation("trav_conf", formStore?.form.dirty);

  return formStore && <TravelConfirmationForm isNew formStore={formStore} />;
});
